/* First-party discovery. Only product IDs/timestamps; Shopify preference permission gates storage. */
(function () {
  'use strict';
  var KEY = 'oxp_discovery_v1';
  var TTL = 30 * 24 * 60 * 60 * 1000;
  var LIMIT = 12;
  function validId(value) { return typeof value === 'string' && /^[1-9]\d{0,19}$/.test(value); }
  function normalize(items, now) {
    if (!Array.isArray(items)) return [];
    var seen = new Set();
    return items.filter(function (item) {
      if (!item || !validId(item.id) || !Number.isFinite(item.at) || item.at > now || now - item.at >= TTL || seen.has(item.id)) return false;
      seen.add(item.id); return true;
    }).sort(function (a, b) { return b.at - a.at; }).slice(0, LIMIT).map(function (item) { return { id: item.id, at: item.at }; });
  }
  function createHistory(storage, permitted, clock) {
    return {
      read: function () {
        if (!permitted()) return [];
        try {
          var store = storage(); var raw = store.getItem(KEY); var data = JSON.parse(raw);
          var items = data && data.v === 1 ? normalize(data.items, clock()) : [];
          var clean = JSON.stringify({ v: 1, items: items });
          if (raw && !items.length) store.removeItem(KEY);
          else if (items.length && raw !== clean) store.setItem(KEY, clean);
          return items;
        } catch (_) { return []; }
      },
      record: function (id) {
        if (!permitted() || !validId(id)) return;
        var items = this.read().filter(function (item) { return item.id !== id; });
        items.unshift({ id: id, at: clock() });
        try { storage().setItem(KEY, JSON.stringify({ v: 1, items: normalize(items, clock()) })); } catch (_) { /* Storage can be blocked. */ }
      },
      clear: function () { try { storage().removeItem(KEY); } catch (_) { /* No other key is touched. */ } }
    };
  }
  function shuffled(items, random) {
    var result = items.slice();
    for (var i = result.length - 1; i > 0; i--) { var j = Math.floor(random() * (i + 1)); var hold = result[i]; result[i] = result[j]; result[j] = hold; }
    return result;
  }
  function choose(pool, related, viewed, previous, random) {
    var used = new Set();
    var excluded = new Set(viewed);
    function unique(items) { return items.filter(function (p) { if (!validId(p.id) || used.has(p.id) || excluded.has(p.id)) return false; used.add(p.id); return true; }); }
    var pickedRelated = unique(shuffled(related, random)).slice(0, 4);
    // Only selected related IDs exclude pool items; unselected recommendations remain eligible.
    used = new Set(pickedRelated.map(function (p) { return p.id; }));
    var candidates = unique(shuffled(pool, random));
    var result = pickedRelated.concat(candidates).slice(0, 8);
    // A small pool still works after a buyer has explored every candidate.
    if (result.length < Math.min(8, pool.length)) {
      excluded.clear(); used = new Set(result.map(function (p) { return p.id; }));
      result = result.concat(unique(shuffled(pool, random))).slice(0, 8);
    }
    if (result.length > 1 && result.map(function (p) { return p.id; }).join('|') === previous.join('|')) result.push(result.shift());
    return { items: result, related: pickedRelated.length };
  }
  function requestURL(route, origin, id) {
    if (!validId(id)) throw new Error('Invalid product ID');
    var url = new URL(route, origin);
    if (url.origin !== origin || !/\/recommendations\/products$/.test(url.pathname)) throw new Error('Invalid recommendation route');
    url.search = ''; url.hash = '';
    url.searchParams.set('product_id', id); url.searchParams.set('limit', '10');
    url.searchParams.set('intent', 'related'); url.searchParams.set('section_id', 'oxp-discovery-recommendations');
    return url.href;
  }
  function createClient(fetcher, route, origin, parse, timeoutMs) {
    var revision = 0; var abort;
    return {
      cancel: function () { revision++; if (abort) abort.abort(); },
      load: async function (id) {
        this.cancel(); var ownRevision = revision;
        abort = new AbortController(); var signal = abort.signal;
        var timer = setTimeout(function () { if (ownRevision === revision) abort.abort(); }, timeoutMs || 4000);
        try {
          var response = await fetcher(requestURL(route, origin, id), { signal: signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unavailable recommendations');
          var html = await response.text();
          if (ownRevision !== revision || signal.aborted) return null;
          return parse(html);
        } catch (_) { return ownRevision === revision ? [] : null; }
        finally { clearTimeout(timer); }
      }
    };
  }
  var api = { KEY: KEY, TTL: TTL, validId: validId, normalize: normalize, createHistory: createHistory, choose: choose, requestURL: requestURL, createClient: createClient };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || window.OpenXDiscovery) return;

  var allowed = false;
  var controllers = new Map();
  var history = createHistory(function () { return window.localStorage; }, function () { return allowed; }, Date.now);
  function currentProduct() {
    var node = document.querySelector('[data-discovery-product]');
    return node ? node.getAttribute('data-discovery-product') : '';
  }
  function readPermission() {
    try { return !window.Shopify.designMode && window.Shopify.customerPrivacy.preferencesProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function processPermission(forceDenied) {
    allowed = forceDenied === true ? false : readPermission();
    if (allowed) history.record(currentProduct()); else history.clear();
    controllers.forEach(function (controller) { controller.update(); });
  }
  function parseCards(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('[data-discovery-response] [data-discovery-card]')).filter(function (card) {
      if (!validId(card.dataset.productId) || card.querySelector('script,iframe,form')) return false;
      return Array.from(card.querySelectorAll('a')).every(function (a) {
        try { var u = new URL(a.getAttribute('href'), location.origin); return u.origin === location.origin && /\/products\/[^/]+$/.test(u.pathname); } catch (_) { return false; }
      });
    }).map(function (card) { return { id: card.dataset.productId, node: card }; });
  }
  function parseCatalogPage(html) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-catalog-page]');
    return node ? JSON.parse(node.textContent) : null;
  }
  function catalogCard(item) {
    function make(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    }
    var card = make('article', 'oxp-discovery-card');
    card.dataset.discoveryCard = ''; card.dataset.productId = item.id;
    var link = make('a', 'oxp-discovery-image');
    link.href = item.url; link.dataset.catalogImageFrame = ''; link.setAttribute('aria-label', item.title);
    if (item.image) {
      var image = make('img'); image.dataset.catalogImage = ''; image.src = item.image;
      image.alt = item.title; image.loading = 'lazy'; image.decoding = 'async';
      image.width = Number.isFinite(item.width) && item.width > 0 ? item.width : 640;
      image.height = Number.isFinite(item.height) && item.height > 0 ? item.height : 640;
      link.appendChild(image);
    }
    var missing = make('span', 'oxp-catalog-image-status', 'Image available on request');
    missing.dataset.catalogImageStatus = ''; missing.hidden = !!item.image; link.appendChild(missing);
    var heading = make('h3'); var title = make('a', '', item.title.length > 84 ? item.title.slice(0, 81) + '...' : item.title);
    title.href = item.url; heading.appendChild(title);
    var details = make('a', 'oxm-text-link', 'View product'); details.href = item.url;
    var arrow = make('span', '', '↗'); arrow.setAttribute('aria-hidden', 'true'); details.appendChild(arrow);
    card.append(link, heading, details);
    return { id: item.id, node: card };
  }
  function init(scope) {
    var roots = scope.matches && scope.matches('[data-discovery]') ? [scope] : Array.from(scope.querySelectorAll('[data-discovery]'));
    roots.forEach(function (root) {
      if (controllers.has(root)) return;
      var track = root.querySelector('[data-product-track]');
      var button = root.querySelector('[data-discovery-refresh]');
      if (!track || !button || !window.OpenXCatalogPages) return;
      var pager;
      try {
        pager = window.OpenXCatalogPages.createPager({ total: Number(root.dataset.catalogCount), route: root.dataset.catalogUrl,
          origin: location.origin, fetcher: window.fetch.bind(window), parse: parseCatalogPage });
      } catch (_) { return; }
      var pool = []; var related = []; var pages = [];
      var previous = Array.from(track.querySelectorAll('[data-discovery-card]')).map(function (card) { return card.dataset.productId; });
      var destroyed = false; var manualMode = false; var busy = false; var pageRevision = 0;
      var client = createClient(window.fetch.bind(window), root.dataset.recommendationsUrl, location.origin, parseCards);
      function visible() { var box = track.getBoundingClientRect(); return box.top < window.innerHeight && box.bottom > 0; }
      function render(manual) {
        if (destroyed || !pool.length) return;
        var recent = allowed && !manualMode ? history.read().map(function (p) { return p.id; }) : [];
        var selected = choose(pool, allowed && !manualMode ? related : [], recent, previous, Math.random);
        if (!selected.items.length) return;
        previous = selected.items.map(function (p) { return p.id; });
        track.replaceChildren.apply(track, selected.items.map(function (p) { return p.node.cloneNode(true); }));
        track.scrollLeft = 0;
        root.dataset.discoveryMode = selected.related ? 'related' : 'catalog';
        root.dataset.discoveryCount = String(selected.items.length);
        root.querySelector('[data-discovery-heading]').textContent = selected.related ? 'Related products.' : 'Explore products.';
        track.dispatchEvent(new CustomEvent('oxp:products:updated'));
        if (manual) root.querySelector('[data-discovery-status]').textContent = 'Selection refreshed. ' + selected.items.length + ' products.';
      }
      async function loadCatalog(manual) {
        var ownRevision = ++pageRevision;
        busy = true; button.disabled = true; track.setAttribute('aria-busy', 'true');
        var label = button.querySelector('[data-discovery-refresh-label]');
        if (label) label.textContent = 'Loading…';
        var status = root.querySelector('[data-discovery-status]');
        status.classList.add('visually-hidden');
        try {
          var batch = await pager.load(pages);
          if (destroyed || ownRevision !== pageRevision || batch === null) return;
          pool = batch.items.map(catalogCard); pages = batch.pages;
          root.dataset.catalogPages = pages.join(','); root.dataset.catalogTotal = String(batch.total);
          status.textContent = ''; render(manual);
        } catch (_) {
          if (!destroyed && ownRevision === pageRevision) {
            status.textContent = 'Could not load new products. Please try Refresh again.';
            status.classList.remove('visually-hidden');
          }
        } finally {
          if (!destroyed && ownRevision === pageRevision) {
            busy = false; button.disabled = false; track.setAttribute('aria-busy', 'false');
            if (label) label.textContent = 'Refresh';
          }
        }
      }
      async function update() {
        client.cancel(); related = [];
        var recent = allowed ? history.read() : [];
        // Preference withdrawal removes personalized output even if it is currently visible.
        if (!allowed) render(false);
        if (!recent.length || manualMode) return;
        var cards = await client.load(recent[0].id);
        if (destroyed || !allowed || manualMode || cards === null) return;
        related = cards;
        // Later related responses must not interrupt reading. Refresh always
        // samples fresh catalog pages instead of retaining personalized slots.
        if (!busy && !visible() && !track.contains(document.activeElement)) render(false);
      }
      function refresh() { manualMode = true; related = []; client.cancel(); loadCatalog(true); }
      button.addEventListener('click', refresh); button.hidden = false;
      controllers.set(root, { update: update, destroy: function () { destroyed = true; pageRevision++; client.cancel(); pager.cancel(); button.removeEventListener('click', refresh); } });
      loadCatalog(false); if (allowed) update(); root.dataset.discoveryReady = 'true';
    });
  }
  function boot() {
    init(document);
    if (window.Shopify && window.Shopify.customerPrivacy) processPermission();
    else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { processPermission(!!error); });
    } else processPermission(true);
  }
  window.OpenXDiscovery = { init: init };
  document.addEventListener('visitorConsentCollected', processPermission);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (controller, root) { if (event.target === root || event.target.contains(root)) { controller.destroy(); controllers.delete(root); } });
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted) processPermission(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
